import { useState } from 'react'
import { Typography } from '@mui/material'
import TokTokDocDialog from '../PlannedExpertiseDeleteDialog/../../Common/Dialog'
import { tanstackQueryClient } from '../../../api/tanstackClient'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import { DeleteBackgroundIcon } from '../../../assets/icons/icons'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import {
    useDeleteIdsHealthcareservicesHcsIdConsultationsConsultationId,
} from '@toktokdoctech/tokapi-client'
import useDeleteStyles from './_deleteStyles'
import { PlannedConsultationDeleteDialogProps } from './_props'

const PlannedConsultationDeleteDialog = ({
    isOpen,
    consultationId,
    onClose,
}: PlannedConsultationDeleteDialogProps) => {
    const dispatch = useAppDispatch()
    const [isDeletionLoading, setIsDeletionLoading] = useState(false)
    const classes = useDeleteStyles()

    const currentHcs = useCurrentHcs()

    const { mutateAsync: deleteConsultation, isPending: isDeletingConsultation } =
        useDeleteIdsHealthcareservicesHcsIdConsultationsConsultationId()

    const handleDelete = async () => {
        setIsDeletionLoading(true)
        try {
            if (!currentHcs?.id) {
                throw new Error('HCS introuvable')
            }
            if (!consultationId) {
                throw new Error('ID téléconsultation introuvable')
            }

            await deleteConsultation({
                hcsId: currentHcs.id,
                consultationId,
            })

            dispatch(
                displaySnackbar(
                    'success',
                    'La téléconsultation a bien été supprimée',
                    undefined,
                    `[PlannedConsultationDeleteDialog] suppression téléconsultation ${consultationId ?? ''}`,
                ),
            )
            await tanstackQueryClient.refetchQueries({
                queryKey: [`/ids/healthcareservices/${currentHcs.id}/consultations`],
                exact: false,
            })
            onClose()

        } catch (error: any) {
            dispatch(
                displaySnackbar(
                    'error',
                    error?.message ?? 'Une erreur est survenue pendant la suppression de la téléconsultation',
                    undefined,
                    `[PlannedConsultationDeleteDialog] error suppression téléconsultation ${consultationId ?? ''}`,
                ),
            )
        } finally {
            setIsDeletionLoading(false)
        }
    }

    return (
        <TokTokDocDialog
            isOpen={isOpen}
            handleClose={onClose}
            handleSave={handleDelete}
            handleCancel={onClose}
            saveTitle="Supprimer"
            title="Êtes-vous sûr de supprimer la téléconsultation ?"
            loading={isDeletionLoading}
            disableEscape={false}
            isDeleteAction
            dialogProps={{
                fullScreen: false,
                slotProps: {
                    backdrop: {
                        className: classes.PlannedConsultationPopUpDeleteBackdrop,
                    },
                },
            }}
        >
            <Typography className={classes.PlannedConsultationPopUpDelete}>
                En poursuivant, la téléconsultation sera définitivement supprimée
            </Typography>

            <DeleteBackgroundIcon />
        </TokTokDocDialog>
    )
}

export default PlannedConsultationDeleteDialog


